import router                from '@/router';
import store                 from '@/store';
import {
    POLL_INTERVAL_HIDDEN_MS,
    TEACHER_DETAIL_POLL_INTERVAL_MS,
    TEACHER_STATUS_POLL_INTERVAL_MS,
    WS_BASE_URL,
} from '@/assets/js/common/app-config';
import { useField, useForm } from 'vee-validate';
import { ref }               from "vue";
import { useRoute }          from 'vue-router'
import { VDataTable }        from 'vuetify/labs/VDataTable'
import * as yup              from 'yup';
import QuestionDataService   from './services/QuestionDataService';
import TestDataService       from './services/TestDataService';
import UserDataService       from './services/UserDataService';

export default {

    name: 'Prova',
    components: { VDataTable },

    data: () => ({
        
        boardSyncStatus: 'idle',
        btnName: '',
        btnNames: ['Iniciar Atividade Avaliativa', 
                  'Encerrar Atividade Avaliativa Individual',
                  'Iniciar Atividade Avaliativa em Equipe',
                  'Finalizar Atividade Avaliativa'],
        dialog: false,
        dialogMsg: 'Você tem certeza que deseja prosseguir?',
        headersClassroom: [
            { title: 'Aluno (a)', key: 'nome', align: 'center', width: '90%' },
            { title: 'Ações', key: 'id', align: 'center', sortable: false, width: '10%' },
        ],
        headersGroups: [
            { title: 'Grupo', key: 'nome', align: 'start' },
            { title: 'Alunos', key: 'nome_usuarios', align: 'start' },
            { title: 'Ações', key: 'id', align: 'center', sortable: false, width: '10%' },
        ],
        headersGroupsTest: [
            { title: 'Grupo', key: 'nome', align: 'start' },
        ],
        headersQuestions: [
            { title: 'Nome', key: 'nome', align: 'start', width: '70%' },
            { title: 'Questões', key: 'perguntas.length', align: 'center', width: '10%' },
            { title: 'Aplicações', key: 'cont', align: 'center', width: '10%' },
            { title: 'Criação', key: 'datetime', align: 'center', width: '10%' },
        ],
        headersStudentsTest: [
            { title: 'Aluno (a)', key: 'nome_usuario', align: 'start' },
        ],
        detailInterval: null,
        detailPollingBusy: false,
        teacherSocket: null,
        teacherSocketProvaId: null,
        teacherSocketReconnectTimer: null,
        teacherSocketShouldReconnect: false,
        groupPhaseComplete: false,
        groupTableKey: 0,
        isFormValid: false,
        classroomItemsPerPage: 10,
        classroomStudentsCount: 0,
        classroomTableKey: 0,
        currentDetailPollingInterval: 0,
        individualPhaseComplete: false,
        individualItemsPerPage: 10,
        individualStudentsCount: 0,
        individualTableKey: 0,
        lastGroupStatusSignature: '',
        lastIndividualStatusSignature: '',
        lastTeacherBoardSignature: '',
        listGroups: [],
        listGroupsTest: [],
        listQuestions: [],
        listStudents: [],
        listStudentsGrades: [],
        listStudentsTest: [],
        listTests: [],
        loadingChangeTestStatus: false,
        loadingGroups: true,
        loadingGroupsTest: true,
        loadingNM: true,
        loadingNI: true,
        loadingNE: true,
        loadingQuestions: true,
        loadingStudents: true,
        loadingStudentsTest: true,
        loadingTests: true,
        loadingDisciplinas: true,
        loadingTurmas: true,
        lastBoardSyncAt: null,
        notaEquipe: null,
        notaIndividual: null,
        notaMaxima: null,
        nAlts: null,
        nQuestoes: null,
        optMixAnswers: false,
        perguntas: [],
        sbColor: '',
        sbMessage: '',
        snackbar: false,
        sortByData: [{ key: 'datetime', order: 'desc' }],
        sortByName: [{ key: 'nome', order: 'asc' }],
        provaId: null,
        provaNome: '',
        provaSenha: '',
        statusNomeProva: '',
        statusProva: '',
        statusProva2: '',
        statusInterval: null,
        statusPollingBusy: false,
        teacherBoardStableCycles: 0,
        provaTurmas: [],
        disciplinas: [],
        turmas: [],
        detailTime: TEACHER_DETAIL_POLL_INTERVAL_MS,
        hiddenTime: POLL_INTERVAL_HIDDEN_MS,
        statusTime: TEACHER_STATUS_POLL_INTERVAL_MS,
    }),

    setup() { 
        const alert            = ref(false);
        const alertText        = ref('');
        const alertType        = ref('success');
        const loadingStartTest = ref(false);
        const route            = useRoute();

        const validationSchema = yup.object().shape({
            nota_maxima: yup.number()
                .integer('O valor deve ser um número inteiro')
                .typeError('O valor deve ser um número válido')
                .notOneOf([0], 'O valor não pode ser zero')
                .required('O campo é obrigatório'),
            nota_individual: yup.number()
                .integer('O valor deve ser um número inteiro')
                .typeError('O valor deve ser um número válido')
                .notOneOf([0], 'O valor não pode ser zero')
                .required('O campo é obrigatório'),
            nota_equipe: yup.number()
                .integer('O valor deve ser um número inteiro')
                .typeError('O valor deve ser um número válido')
                .notOneOf([0], 'O valor não pode ser zero')
                .required('O campo é obrigatório')
                .test('equal 100', 'A soma da nota individual com a da equipe tem que ser 100%', function(value) {
                    const { nota_individual } = this.parent;
                    return value + nota_individual === 100;
                }),
            disciplina: yup.string()
                .trim()
                .required('Selecione a disciplina'),
            selected_turmas: yup.array()
                .min(1, 'Selecione pelo menos uma turma')
                .required('Selecione pelo menos uma turma'),
        });
        
        const { handleSubmit, handleReset } = useForm({
            validationSchema,
            initialValues: {
                nota_individual: '70',
                nota_equipe: '30',
                disciplina: '',
                selected_turmas: [],
            }
        });

        const nota_maxima     = useField('nota_maxima', validationSchema);
        const nota_individual = useField('nota_individual', validationSchema);
        const nota_equipe     = useField('nota_equipe', validationSchema);
        const disciplina      = useField('disciplina', validationSchema);
        const opt_mix_answers = useField('opt_mix_answers', validationSchema);
        const selected_turmas = useField('selected_turmas', validationSchema);

        const onSubmit = handleSubmit(async (values) => {
            loadingStartTest.value = true;
            const response  = await QuestionDataService.read(route.params.id);
            const id        = response.data.id;
            const nome      = response.data.nome;
            const perguntas = response.data.perguntas;
            const cont      = response.data.cont;
            
            if (typeof values.opt_mix_answers === 'undefined'){ values.opt_mix_answers=false }

            await TestDataService.create({usuario: store.state.userId, nome: nome, disciplina: values.disciplina, perguntas: perguntas, nota_maxima: values.nota_maxima, 
            nota_individual: values.nota_individual, nota_equipe: values.nota_equipe, opt_mix_answers: values.opt_mix_answers, turmas: values.selected_turmas}).then(response => {
                TestDataService.createClassroom({prova: response.data.id})
                QuestionDataService.update({id: id, cont: cont+1})
                router.push({ path: '/Prova/Prova/'+response.data.id });
            }).catch(error => {
                alertType.value = 'error';
                alertText.value = error.message;
                alert.value     = true;
            })
            loadingStartTest.value = false;
            handleReset();
        });

        return { alert, alertType, alertText, loadingStartTest, nota_maxima, nota_individual, nota_equipe, disciplina, opt_mix_answers, selected_turmas, onSubmit, handleReset };
    },

    mounted() {
        this.loadTurmas();
        this.loadDisciplinas();
        if (typeof document !== 'undefined') {
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('focus', this.handleWindowFocus);
            window.addEventListener('pageshow', this.handleWindowFocus);
        }
        this.handlePageChange(this.currentParamsPage);
    },

    beforeUnmount() {
        this.stopPolling();
        if (typeof document !== 'undefined') {
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        }
        if (typeof window !== 'undefined') {
            window.removeEventListener('focus', this.handleWindowFocus);
            window.removeEventListener('pageshow', this.handleWindowFocus);
        }
    },

    computed: {
        currentParamsPage() {
            return this.$route.params;
        },
        phaseMeta() {
            if (this.statusProva === '1') {
                return { color: 'info', icon: 'mdi-chair-school', label: 'Sala de Espera', panelClass: 'phase-panel--waiting' };
            }

            if (this.statusProva === '2') {
                return { color: 'warning', icon: 'mdi-note-edit-outline', label: 'Etapa Individual', panelClass: 'phase-panel--individual' };
            }

            if (this.statusProva === '3') {
                return { color: 'secondary', icon: 'mdi-account-group', label: 'Formação de Equipes', panelClass: 'phase-panel--grouping' };
            }

            if (this.statusProva === '4') {
                return { color: 'success', icon: 'mdi-account-multiple-check', label: 'Etapa em Equipe', panelClass: 'phase-panel--team' };
            }

            if (this.statusProva === '5') {
                return { color: 'secondary', icon: 'mdi-flag-checkered', label: 'Concluída', panelClass: 'phase-panel--done' };
            }

            if (this.statusProva === '6') {
                return { color: 'error', icon: 'mdi-close-octagon', label: 'Interrompida', panelClass: 'phase-panel--stopped' };
            }

            return { color: 'info', icon: 'mdi-information', label: 'Em andamento', panelClass: 'phase-panel--waiting' };
        },
        activitySummaryItems() {
            return [
                { label: 'Questionário', value: this.provaNome || '--' },
                { label: 'Questões', value: this.nQuestoes || '--' },
                { label: 'Nota máxima', value: this.notaMaxima || '--' },
                { label: 'Peso individual', value: this.notaIndividual ? `${this.notaIndividual}%` : '--' },
                { label: 'Peso equipe', value: this.notaEquipe ? `${this.notaEquipe}%` : '--' },
                { label: 'Turmas', value: this.provaTurmasLabel || '--' },
                { label: 'Embaralhamento', value: this.optMixAnswers ? 'Ligado' : 'Desligado' },
                { label: 'Fase', value: this.phaseMeta.label },
            ];
        },
        provaTurmasLabel() {
            return Array.isArray(this.provaTurmas) && this.provaTurmas.length
                ? this.provaTurmas.join(', ')
                : '';
        },
        syncStatusMeta() {
            if (this.boardSyncStatus === 'syncing') {
                return { color: 'info', icon: 'mdi-sync', text: 'Sincronizando...' };
            }

            if (this.boardSyncStatus === 'error') {
                return { color: 'error', icon: 'mdi-alert-circle', text: 'Atualizacao com erro' };
            }

            if (this.lastBoardSyncAt) {
                return { color: 'success', icon: 'mdi-check-circle', text: `Atualizado ${this.formatTime(this.lastBoardSyncAt)}` };
            }

            return { color: 'secondary', icon: 'mdi-timer-sand', text: 'Aguardando dados' };
        },
        individualSummary() {
            const total = this.individualStudentsCount || this.listStudentsTest.length;
            const completed = this.listStudentsTest.filter((item) => parseInt(item.respostas_count || 0) >= this.nQuestoes).length;
            const inProgress = this.listStudentsTest.filter((item) => {
                const count = parseInt(item.respostas_count || 0);
                return count > 0 && count < this.nQuestoes;
            }).length;

            return {
                total,
                completed,
                inProgress,
                pending: Math.max(total - completed - inProgress, 0),
            };
        },
        groupSummary() {
            const total = this.listGroupsTest.length || this.listGroups.length;
            const completed = this.listGroupsTest.filter((item) => parseInt(item.respostas_count || 0) >= this.nQuestoes).length;
            const inProgress = this.listGroupsTest.filter((item) => {
                const count = parseInt(item.respostas_count || 0);
                return count > 0 && count < this.nQuestoes;
            }).length;

            return {
                total,
                completed,
                inProgress,
                pending: Math.max(total - completed - inProgress, 0),
            };
        },
        liveStatusCards() {
            if (this.statusProva === '1') {
                return [
                    { title: 'Na sala', value: this.classroomStudentsCount || this.listStudents.length, subtitle: 'alunos presentes', icon: 'mdi-account-group', tone: 'info' },
                    { title: 'Atualizacao', value: this.syncStatusMeta.text, subtitle: 'monitoramento da sala', icon: this.syncStatusMeta.icon, tone: this.syncStatusMeta.color },
                ];
            }

            if (this.statusProva === '2') {
                return [
                    { title: 'Na atividade', value: this.individualSummary.total, subtitle: 'alunos acompanhados', icon: 'mdi-account-group', tone: 'info' },
                    { title: 'Concluíram', value: this.individualSummary.completed, subtitle: 'atividade individual', icon: 'mdi-check-decagram', tone: 'success' },
                    { title: 'Respondendo', value: this.individualSummary.inProgress, subtitle: 'atividade individual', icon: 'mdi-progress-clock', tone: 'warning' },
                    { title: 'Sem resposta', value: this.individualSummary.pending, subtitle: 'atividade individual', icon: 'mdi-account-clock', tone: 'secondary' },
                ];
            }

            if (this.statusProva === '3') {
                return [
                    { title: 'Grupos', value: this.listGroups.length, subtitle: 'equipes formadas', icon: 'mdi-account-multiple', tone: 'info' },
                    { title: 'Atualizacao', value: this.syncStatusMeta.text, subtitle: 'preparacao da equipe', icon: this.syncStatusMeta.icon, tone: this.syncStatusMeta.color },
                ];
            }

            if (this.statusProva === '4') {
                return [
                    { title: 'Grupos', value: this.groupSummary.total, subtitle: 'equipes acompanhadas', icon: 'mdi-account-multiple', tone: 'info' },
                    { title: 'Concluíram', value: this.groupSummary.completed, subtitle: 'atividade em equipe', icon: 'mdi-check-decagram', tone: 'success' },
                    { title: 'Respondendo', value: this.groupSummary.inProgress, subtitle: 'atividade em equipe', icon: 'mdi-progress-clock', tone: 'warning' },
                    { title: 'Sem resposta', value: this.groupSummary.pending, subtitle: 'atividade em equipe', icon: 'mdi-account-clock', tone: 'secondary' },
                ];
            }

            return [
                { title: 'Atualizacao', value: this.syncStatusMeta.text, subtitle: 'monitoramento da atividade', icon: this.syncStatusMeta.icon, tone: this.syncStatusMeta.color },
            ];
        },
    },

    watch: {
        alert(new_val){
            if(new_val){
              setTimeout(()=>{this.alert=false}, 5000)
            }
        },  
        currentParamsPage(newVal, oldVal) {
            this.handlePageChange(newVal);
        },
    },

    methods: {

        normalizeTurmas(turmas) {
            return (Array.isArray(turmas) ? turmas : [])
                .map((turma) => ({
                    id: turma.id || turma.codigo,
                    codigo: String(turma.codigo || turma.nome || '').toUpperCase(),
                    nome: turma.nome || `Turma ${turma.codigo}`,
                    label: String(turma.codigo || turma.nome || '').toUpperCase(),
                }))
                .filter((turma) => turma.codigo)
                .sort((a, b) => a.codigo.localeCompare(b.codigo, 'pt-BR', { sensitivity: 'base' }));
        },

        async loadTurmas() {
            this.loadingTurmas = true;
            try {
                const response = await UserDataService.listTurmas();
                this.turmas = this.normalizeTurmas(response.data || []);
            } catch (error) {
                console.log(error);
                this.turmas = [];
            } finally {
                this.loadingTurmas = false;
            }
        },

        async loadDisciplinas() {
            this.loadingDisciplinas = true;
            try {
                const response = await UserDataService.listProfessorDisciplinasTurmas();
                const nomes = new Set(
                    (Array.isArray(response.data) ? response.data : [])
                        .map((item) => String(item.disciplina || '').trim())
                        .filter(Boolean)
                );
                this.disciplinas = Array.from(nomes).sort((a, b) =>
                    a.localeCompare(b, 'pt-BR', { sensitivity: 'base' })
                );
            } catch (error) {
                console.log(error);
                this.disciplinas = [];
            } finally {
                this.loadingDisciplinas = false;
            }
        },

        clearPollingTimer(timerName) {
            if (this[timerName]) {
                clearInterval(this[timerName]);
                this[timerName] = null;
            }
        },

        markBoardSync(status) {
            this.boardSyncStatus = status;
            if (status === 'ok') {
                this.lastBoardSyncAt = new Date();
            }
        },

        getAdaptivePollInterval(baseInterval) {
            if (typeof document !== 'undefined' && document.hidden) {
                return Math.max(this.hiddenTime, baseInterval);
            }
            return baseInterval;
        },

        handleVisibilityChange() {
            if (this.currentParamsPage.pPage === 'Prova') {
                this.handlePageChange(this.currentParamsPage);
            }
        },

        async handleWindowFocus() {
            if (this.currentParamsPage.pPage !== 'Prova' || this.loadingChangeTestStatus) {
                return;
            }

            this.resetTeacherBoardPollingState();
            await this.syncTeacherStatus();
            if (this.provaId) {
                await this.refreshTeacherBoard(this.provaId, true);
            }
        },

        resetCompletionFlags() {
            this.individualPhaseComplete = false;
            this.groupPhaseComplete = false;
        },

        resetTeacherBoardPollingState() {
            this.currentDetailPollingInterval = 0;
            this.lastTeacherBoardSignature = '';
            this.teacherBoardStableCycles = 0;
        },

        buildClassroomStatusSignature(data) {
            return JSON.stringify(
                [...data]
                    .map((item) => item?.id || item?.usuario || item?.email || item?.nome || '')
                    .filter(Boolean)
                    .sort()
            );
        },

        buildIndividualStatusSignature(data) {
            return JSON.stringify(
                data.map((item) => ({
                    id: item.usuario || item.id || item.nome_usuario,
                    respostas_count: item.respostas_count || 0,
                    status: Array.isArray(item.respostas)
                        ? item.respostas.map((question) => question?.status || '')
                        : [],
                }))
            );
        },

        buildGroupStatusSignature(data) {
            return JSON.stringify(
                data.map((item) => ({
                    id: item.grupo || item.id || item.nome,
                    respostas_count: item.respostas_count || 0,
                    status: item.respostas
                        ? Object.keys(item.respostas)
                            .sort()
                            .map((key) => item.respostas[key]?.status || '')
                        : [],
                }))
            );
        },

        buildPendingGroupStatusSignature(data) {
            return JSON.stringify(
                [...data]
                    .map((item) => ({
                        id: item?.id || item?.grupo || item?.nome || '',
                        membros: Array.isArray(item?.id_usuarios)
                            ? [...item.id_usuarios].sort()
                            : String(item?.nome_usuarios || ''),
                    }))
                    .sort((left, right) => String(left.id).localeCompare(String(right.id)))
            );
        },

        registerTeacherBoardSnapshot(signature) {
            if (signature === this.lastTeacherBoardSignature) {
                this.teacherBoardStableCycles += 1;
            } else {
                this.lastTeacherBoardSignature = signature;
                this.teacherBoardStableCycles = 0;
            }

            this.startTeacherDetailPolling();
        },

        getTeacherDetailPollInterval() {
            let interval = this.detailTime;

            if (this.statusProva === '1' || this.statusProva === '3') {
                interval = Math.max(interval, Math.round(this.detailTime * 1.5));
            } else if (this.statusProva === '2' || this.statusProva === '4') {
                interval = Math.max(interval, Math.round(this.detailTime * 1.2));
            } else {
                interval = Math.max(interval, Math.round(this.detailTime * 2));
            }

            if (this.teacherBoardStableCycles >= 2) {
                interval = Math.max(interval, Math.round(interval * 1.6));
            }

            if (this.teacherBoardStableCycles >= 4) {
                interval = Math.max(interval, Math.round(interval * 2.2));
            }

            return interval;
        },

        schedulePolling(timerName, busyFlagName, task, baseInterval) {
            this.clearPollingTimer(timerName);
            this[timerName] = setInterval(async () => {
                if (this[busyFlagName] || this.loadingChangeTestStatus) {
                    return;
                }

                this[busyFlagName] = true;
                try {
                    await task();
                } finally {
                    this[busyFlagName] = false;
                }
            }, this.getAdaptivePollInterval(baseInterval));
        },

        startTeacherDetailPolling(force = false) {
            const nextInterval = this.getAdaptivePollInterval(this.getTeacherDetailPollInterval());

            if (!force && this.detailInterval && this.currentDetailPollingInterval === nextInterval) {
                return;
            }

            this.currentDetailPollingInterval = nextInterval;
            this.schedulePolling(
                'detailInterval',
                'detailPollingBusy',
                async () => {
                    if (this.provaId) {
                        await this.refreshTeacherBoard(this.provaId);
                    }
                },
                nextInterval,
            );
        },

        async syncTeacherStatus() {
            const previousStatus = this.statusProva;
            const previousProvaId = this.provaId;
            const activeStatus = await this.getActiveTestStatus();

            if (activeStatus === 0) {
                this.stopPolling();
                if (this.currentParamsPage.pPage === 'Prova') {
                    router.push({ path: '/Prova/Aplicar/' });
                }
                return;
            }

            if (activeStatus !== null) {
                this.provaId = activeStatus.id;

                if (previousStatus !== activeStatus.status || previousProvaId !== activeStatus.id) {
                    this.resetCompletionFlags();
                    this.resetTeacherBoardPollingState();
                    const provaId = await this.isTestActivated();
                    if (provaId !== null && provaId !== 0) {
                        await this.refreshTeacherBoard(provaId, true);
                    }
                    return;
                }

                this.statusProva = activeStatus.status;
                this.statusNomeProva = activeStatus.get_status_display;
            }
        },

        startTeacherPolling() {
            this.schedulePolling(
                'statusInterval',
                'statusPollingBusy',
                async () => {
                    await this.syncTeacherStatus();
                },
                this.statusTime,
            );
            this.startTeacherDetailPolling(true);
            if (this.provaId) {
                this.connectTeacherSocket(this.provaId);
            }
        },

        stopPolling() {
            this.clearPollingTimer('statusInterval');
            this.clearPollingTimer('detailInterval');
            this.disconnectTeacherSocket();
        },

        // Gatilho extra sobre o polling existente: quando o status da prova
        // muda (inicio, fim da fase individual, fase em equipe, finalizacao),
        // o WebSocket avisa na hora em vez de esperar o proximo ciclo do
        // polling. Se a conexao cair ou nao abrir, o polling normal continua
        // funcionando sem nenhuma dependencia do socket.
        connectTeacherSocket(provaId) {
            if (!provaId || typeof WebSocket === 'undefined') {
                return;
            }
            if (this.teacherSocket && this.teacherSocketProvaId === provaId) {
                const openStates = [WebSocket.CONNECTING, WebSocket.OPEN];
                if (openStates.includes(this.teacherSocket.readyState)) {
                    return;
                }
            }

            this.disconnectTeacherSocket();

            const token = localStorage.getItem('token');
            if (!token) {
                return;
            }

            this.teacherSocketProvaId = provaId;
            this.teacherSocketShouldReconnect = true;

            let socket;
            try {
                socket = new WebSocket(
                    `${WS_BASE_URL}/ws/prova/${provaId}/?token=${encodeURIComponent(token)}`
                );
            } catch (_error) {
                return;
            }
            this.teacherSocket = socket;

            socket.onmessage = (event) => {
                let payload = null;
                try {
                    payload = JSON.parse(event.data);
                } catch (_error) {
                    return;
                }
                // O servidor ja filtra por prova_id antes de enviar (ver
                // consumers.py), entao qualquer mensagem recebida aqui e
                // relevante para esta prova.
                if (!payload?.action) {
                    return;
                }

                this.syncTeacherStatus();

                // Eventos granulares (aluno/grupo respondeu, grupo
                // criado/alterado) nao mudam o status da prova, entao
                // forcamos tambem uma atualizacao do board da fase atual.
                if (payload.event && this.provaId) {
                    this.refreshTeacherBoard(this.provaId, true);
                }
            };

            socket.onclose = () => {
                if (this.teacherSocket === socket) {
                    this.teacherSocket = null;
                }
                if (this.teacherSocketShouldReconnect) {
                    this.scheduleTeacherSocketReconnect(provaId);
                }
            };

            socket.onerror = () => {
                socket.close();
            };
        },

        scheduleTeacherSocketReconnect(provaId) {
            if (this.teacherSocketReconnectTimer) {
                clearTimeout(this.teacherSocketReconnectTimer);
            }
            this.teacherSocketReconnectTimer = setTimeout(() => {
                this.teacherSocketReconnectTimer = null;
                if (this.teacherSocketShouldReconnect && this.provaId === provaId) {
                    this.connectTeacherSocket(provaId);
                }
            }, 4000);
        },

        disconnectTeacherSocket() {
            this.teacherSocketShouldReconnect = false;
            if (this.teacherSocketReconnectTimer) {
                clearTimeout(this.teacherSocketReconnectTimer);
                this.teacherSocketReconnectTimer = null;
            }
            if (this.teacherSocket) {
                const socket = this.teacherSocket;
                this.teacherSocket = null;
                socket.onclose = null;
                socket.onerror = null;
                socket.close();
            }
        },

        cancelTestAsk() {
            this.statusProva2 = '6';
            this.dialog       = true;
        },

        shouldRetryStatusChange(error) {
            const statusCode = error?.response?.status;
            if (statusCode === 500 || statusCode === 502 || statusCode === 503 || statusCode === 504) {
                return true;
            }

            const message = String(error?.message || '').toLowerCase();
            return message.includes('timeout') || message.includes('network') || message.includes('request failed');
        },

        async updateTestStatusWithRetry(payload, maxAttempts = 2) {
            let lastError = null;

            for (let attempt = 1; attempt <= maxAttempts; attempt++) {
                try {
                    return await TestDataService.update(payload);
                } catch (error) {
                    lastError = error;
                    if (attempt >= maxAttempts || !this.shouldRetryStatusChange(error)) {
                        throw error;
                    }

                    await new Promise(resolve => setTimeout(resolve, 900));
                }
            }

            throw lastError;
        },

        async changeTestStatus(id, statusId, confirmAsk) {
            this.loadingChangeTestStatus = true;
            this.stopPolling();
            await this.updateTestStatusWithRetry({id: id, status: statusId, confirmAsk: confirmAsk}).then(response => {
                let msg = '';
                let url = '/Prova/Aplicar';
                if (statusId === 2) {msg = 'A atividade avaliativa foi iniciada!';}
                else if (statusId === 3) {msg = 'Atividade avaliativa individual encerrada!';}
                else if (statusId === 4) {msg = 'Atividade avaliativa em equipe iniciada!';}
                else if (statusId === 5) {msg = 'Atividade avaliativa finalizada!';}
                //else if (statusId === 5) {msg = 'Atividade avaliativa finalizada!'; url='/Provas/Listar/';}
                else if (statusId === 6) {msg = 'A atividade avaliativa foi interrompida!';}
                this.resetCompletionFlags();
                this.sbColor   = 'success';
                this.sbMessage = msg;
                this.dialog    = false;
                router.push({ path: url })
            }).catch(error => {
                const backendMessage = error?.response?.data?.error || error.message || 'Erro ao atualizar o status da atividade avaliativa!';
                this.sbColor   = 'error';
                this.sbMessage = backendMessage;
                if (this.sbMessage.includes('aluno') && this.sbMessage.includes('respondendo')) {
                    this.statusProva2 = '3';
                    this.dialog       = true;
                }
                if (this.sbMessage.includes('sem grupo')) {
                    this.statusProva2 = '4' ;
                    this.dialog       = true;
                }
                if (this.sbMessage.includes('grupo') && this.sbMessage.includes('respondendo')) {
                    this.statusProva2 = '5' ;
                    this.dialog       = true;
                }
            })
            this.snackbar = true;
            this.loadingChangeTestStatus = false;
            if (this.currentParamsPage.pPage === 'Prova') {
                this.resetTeacherBoardPollingState();
                await this.syncTeacherStatus();
                if (this.provaId) {
                    await this.refreshTeacherBoard(this.provaId, true);
                }
                this.startTeacherPolling();
            }
        },

        async checkQuestion() {
            try {await QuestionDataService.read(this.$route.params.id);} catch (error) {
                this.getQuestions();
                router.push({ path: '/Prova/Aplicar/' });
            }
        },

        closeDialog () {
            this.dialog = false
        },

        async deleteGroup(id, groupId) {
            await TestDataService.deleteGroup(id, groupId).then(response => {
                this.sbColor   = 'success';
                this.sbMessage = 'O grupo foi removido!';
                this.getGroups(id);
            }).catch(error => {
                this.sbColor   = 'error';
                this.sbMessage = 'Erro ao remover grupo!';
            })
            this.snackbar  = true;
        },

        async deleteStudent(id, userId) {
            await TestDataService.deleteStudent(id, userId).then(response => {
                this.sbColor   = 'success';
                this.sbMessage = 'O aluno foi retirado da sala!';
                this.getStudents(id);
            }).catch(error => {
                this.sbColor   = 'error';
                this.sbMessage = 'Erro ao retirar o aluno da sala!';
            })
            this.snackbar  = true;
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            // Then specify how you want your dates to be formatted
            return new Intl.DateTimeFormat('pt-BR', {timeZone: 'America/Sao_Paulo'}).format(date);
        },

        formatTime(dateValue) {
            const date = dateValue instanceof Date ? dateValue : new Date(dateValue);
            return new Intl.DateTimeFormat('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                timeZone: 'America/Sao_Paulo',
            }).format(date);
        },

        gamb(key) {
            // simple string interpolation
            return `respostas[${key}].status`;
        },

        gamb2(key) {
            // simple string interpolation
            return `respostas[question${key+1}].status`;
        },

        async refreshTeacherBoard(id, force = false) {
            if (this.loadingChangeTestStatus) {
                return;
            }
            this.markBoardSync('syncing');
            if (this.statusProva === '1') {
                return this.getStudents(id);
            }
            else if (this.statusProva === '2') {
                if (!force && this.individualPhaseComplete) {
                    this.registerTeacherBoardSnapshot(`phase-${this.statusProva}-complete`);
                    this.markBoardSync('ok');
                    return;
                }
                return this.getStudentsTest(id);
            }
            else if (this.statusProva === '3') {
                return this.getGroups(id);
            }
            else if (this.statusProva === '4') {
                if (!force && this.groupPhaseComplete) {
                    this.registerTeacherBoardSnapshot(`phase-${this.statusProva}-complete`);
                    this.markBoardSync('ok');
                    return;
                }
                return this.getGroupsTest(id);
            }
            this.markBoardSync('ok');
        },

        getGroups(id) {
            return TestDataService.listGroups(id).then(response => {
                const data = response.data;

                this.listGroups    = data;
                this.loadingGroups = false;
                this.registerTeacherBoardSnapshot(this.buildPendingGroupStatusSignature(data));
                this.markBoardSync('ok');
            }).catch(error => {
                this.markBoardSync('error');
                console.log(error);
            })
        },

        getGroupsTest(id) {
            
            return TestDataService.listGroupsTest(id).then(response => {

                const data       = response.data;
                const numResults = data.length;
                const statusOnly = numResults > 0 && data[0].status_only === true;
                const statusSignature = this.buildGroupStatusSignature(data);
                
                if (numResults > 0) {

                    if (this.headersGroupsTest.length > 1) {
                        // Remova todos os elementos, exceto o primeiro (a partir do índice 1)
                        this.headersGroupsTest.splice(1);
                    }
                    
                    for (let i = 0; i < this.nQuestoes; i++) {
                        this.headersGroupsTest.push({ title: `Questão ${i+1}`, key: `respostas[question${i+1}].status`, align: 'center', sortable: false });
                    }
                    
                    if (!statusOnly) {
                    for (let i = 0; i < numResults; i++) {
                        for (let j = 0; j < this.nQuestoes; j++)
                        {   
                            let altTrue = parseInt(this.perguntas[j].altTrue);
                            let answer  = data[i].respostas['question' + (j+1)];
                            let foundCorrect = false;
                            if (answer) {   
                                for (let l = 0; l < answer.length; l++) {
                                    if (parseInt(answer[l]) === altTrue) { 
                                        foundCorrect = true;
                                        if (l === 0) { answer.status = 'certo'; }
                                        else if (l > 0 && l < (this.nAlts - 1)) { answer.status = 'quase'; }
                                        else if (l === (this.nAlts - 1)) { answer.status = 'errado'; }
                                        break;
                                    }
                                }

                                if (!foundCorrect && Array.isArray(answer) && answer.length >= this.nAlts) {
                                    answer.status = 'errado';
                                }
                            }
                        }
                    }
                    }

                }

                if (statusSignature !== this.lastGroupStatusSignature) {
                    this.lastGroupStatusSignature = statusSignature;
                    this.groupTableKey += 1;
                }

                this.listGroupsTest    = data;
                this.groupPhaseComplete = numResults > 0 && data.every(item => parseInt(item.respostas_count || 0) >= this.nQuestoes);
                this.loadingGroupsTest = false;
                this.registerTeacherBoardSnapshot(statusSignature);
                this.markBoardSync('ok');

            }).catch(error => {
                this.markBoardSync('error');
                console.log(error);
            })
        },

        async getQuestions() {
            await QuestionDataService.list().then(response => {
                this.listQuestions    = response.data;
                this.loadingQuestions = false;
            }).catch(error => {
                console.log(error);
            })
        },

        getStudents(id) {
            return TestDataService.listStudents(id).then(response => {
                const students = [...(response.data[0]?.usuarios || [])];

                if (students.length !== this.classroomStudentsCount) {
                    this.classroomStudentsCount = students.length;
                    this.classroomTableKey += 1;
                }

                this.listStudents    = students;
                this.loadingStudents = false;
                this.registerTeacherBoardSnapshot(this.buildClassroomStatusSignature(students));
                this.markBoardSync('ok');
            }).catch(error => {
                this.markBoardSync('error');
                console.log(error);
            })
        },

        getStudentsTest(id) {
            
            return TestDataService.listStudentsTest(id).then(response => {

                const data       = [...response.data];
                const numResults = data.length;
                const statusOnly = numResults > 0 && data[0].status_only === true;
                const statusSignature = this.buildIndividualStatusSignature(data);

                if (numResults !== this.individualStudentsCount) {
                    this.individualStudentsCount = numResults;
                    this.individualTableKey += 1;
                }
                
                if (numResults > 0) {

                    if (this.headersStudentsTest.length > 1) {
                        this.headersStudentsTest.splice(1);
                    }
                    
                    for (let i = 0; i < this.nQuestoes; i++) {
                        this.headersStudentsTest.push({ title: `Questão ${i+1}`, key: `respostas[${i}].status`, align: 'center', sortable: false });
                    }
                    
                    if (!statusOnly) {
                    for (let i = 0; i < numResults; i++) {
                        for (let j = 0; j < this.nQuestoes; j++) {   
                            const altTrue = parseInt(this.perguntas[j].altTrue);
                            for (let l = 0; l < this.nAlts; l++) {   
                                const altPos  = l + 1;
                                if (data[i].respostas[j]?.answers[l].answer) {
                                    const answer = parseInt(data[i].respostas[j].answers[l].answer);
                                    if (altPos === altTrue) {
                                        if (answer === this.nAlts) { data[i].respostas[j].status = 'certo'; }
                                        else if (answer < this.nAlts && answer > 0) { data[i].respostas[j].status = 'quase'; }
                                        else if (answer === 0) { data[i].respostas[j].status = 'errado'; }
                                    }
                                }
                            }
                        }
                    }
                    }
                }

                if (statusSignature !== this.lastIndividualStatusSignature) {
                    this.lastIndividualStatusSignature = statusSignature;
                    this.individualTableKey += 1;
                }

                this.listStudentsTest    = data;
                this.individualPhaseComplete = numResults > 0 && data.every(item => parseInt(item.respostas_count || 0) >= this.nQuestoes);
                this.loadingStudentsTest = false;
                this.registerTeacherBoardSnapshot(statusSignature);
                this.markBoardSync('ok');

            }).catch(error => {
                this.markBoardSync('error');
                console.log(error);
            })
        },

        async handlePageChange(params) {

            try {

                this.stopPolling();
                this.resetCompletionFlags();
                this.resetTeacherBoardPollingState();

                const provaId = await this.isTestActivated();
                
                if((params.pPage === 'Aplicar' && provaId !== 0) || params.pPage === 'Prova') {
                    if (provaId === null || provaId === 0) {
                        if (params.pPage === 'Prova') {
                            router.push({ path: '/Prova/Aplicar/' });
                        }
                        return;
                    }
                    
                    if (provaId !== null && provaId !== 0) {
                        await this.refreshTeacherBoard(provaId, true);
                        this.startTeacherPolling();
                        if (this.$route.path !== `/Prova/Prova/${provaId}`) {
                            router.push({ path: '/Prova/Prova/' + provaId });
                        }
                        
                        /*#################### TESTES COM O WEBSOCKET (EM IMPLEMENTAÇÃO) ###################
                        
                        let token = localStorage.getItem('token')
                        var ws    = new WebSocket("ws://192.168.56.101:8000/ws/");
                        
                        ws.onopen = function (e) {
                            console.log("Conexão WebSocket aberta");
                            ws.send(
                                JSON.stringify({
                                    action: 'retrieve',
                                    request_id: 107,
                                })
                            );
                        };

                        ws.onmessage = function (e) {
                            let allData = JSON.parse(e.data);
                            //console.log(allData)
                            if (allData.action === 'update') {
                                console.log(allData.data)
                            }
                        };

                        //if(ws) {ws.close();}

                        //##################################################################################*/
                        
                    }
                    else if (false && this.statusProva === '2') { this.interval = setInterval(async () => {this.getStudentsTest(provaId)}, this.time); }
                    else if (false && this.statusProva === '3') { this.interval = setInterval(async () => {this.getGroups(provaId)}, this.time); }
                    else if (false && this.statusProva === '4') { this.interval = setInterval(async () => {this.getGroupsTest(provaId)}, this.time); }

                    if(false && provaId !== null) { router.push({ path: '/Prova/Prova/' + provaId }); }
                }
                else {
                    if (params.pPage === 'Aplicar' && typeof params.id !== 'undefined') { this.checkQuestion(); }
                    else if (params.pPage === 'Aplicar') { this.getQuestions(); }
                    else if (params.pPage === 'Prova') { router.push({ path: '/Prova/Aplicar/' }); }
                }
                
            } catch (error) { console.log(error); }
        },

        async getActiveTestStatus() {
            try {
                const response = await TestDataService.activeStatus();

                if (response.data.length === 1) {
                    return response.data[0];
                }

                return 0;
            } catch (error) {
                this.sbColor   = 'error';
                this.sbMessage = error.response.data.error;
                this.snackbar  = true;
                return null;
            }
        },

        async isTestActivated() {
            try {
                const response = await TestDataService.isTestActivated();

                if (response.data.length === 1) {
                    this.loadingNM       = false;
                    this.loadingNI       = false;
                    this.loadingNE       = false;
                    this.provaId         = response.data[0].id;
                    this.provaNome       = response.data[0].nome;
                    this.provaSenha      = response.data[0].senha;
                    this.perguntas       = response.data[0].perguntas;
                    this.nAlts           = response.data[0].perguntas[0].answers.length;
                    this.nQuestoes       = response.data[0].perguntas.length;
                    this.optMixAnswers   = response.data[0].opt_mix_answers === true;
                    this.statusProva     = response.data[0].status;
                    this.statusNomeProva = response.data[0].get_status_display;
                    this.notaMaxima      = response.data[0].nota_maxima;
                    this.notaIndividual  = response.data[0].nota_individual;
                    this.notaEquipe      = response.data[0].nota_equipe;
                    this.provaTurmas     = response.data[0].turmas || [];
                    this.btnName         = this.btnNames[parseInt(this.statusProva)-1]
                    return this.provaId;
                } 
                return 0;
            } catch (error) {
                this.sbColor   = 'error';
                this.sbMessage = error.response.data.error;
                this.snackbar  = true;
                return null;
            }
        },

        rowClick(item, row) {      
            //store.commit('changeTestId', row.item.value);
            router.push({path: '/Prova/Aplicar/'+row.item.value});
        },

    },
};
